import templateUrl from './report-repository-list.html';

export const reportRepositoryListComponent = {
	bindings: {
		details: '<',
		slugUrl: '@',
		pageTitle: '@',
		onEditOverview: '&',
		onEdit: '&',
		onDelete: '&',
		onViewDetails: '&'
	},

	templateUrl,

	controller: class ReportRepositoryListComponent {
		constructor($state, SlugService) {
			'ngInject';

			this.$state = $state;
			this.slugService = SlugService;
		}

		routeDetailsPageUrl(slug) {
			const url = this.slugService.getDetailsPageURL(slug);

			this.$state.go('app.dashboard.DynamicMenus', {
                url
            });
		}

		routeEditPageUrl(slug) {
			const url = this.slugService.getEditPageURL(slug);

			this.$state.go('app.dashboard.DynamicMenus', {
                url
            });
		}

		routeAddPageUrl() {
			const url = this.slugService.getAddPageURL(this.slugUrl);

			this.$state.go('app.dashboard.DynamicMenus', {
				url
			});
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/common/components/report-repository/report-repository-list/report-repository-list.component.js